import React from 'react'

const ColorContext = React.createContext({})
export default ColorContext
